import React, { useEffect, useRef } from 'react';
import DOMPurify from 'dompurify';

const Jiraintercomdescription = ({ data }) => {
  const sanitizedHTML = DOMPurify.sanitize(data);
  const containerRef = useRef();
  const containerStyle = {
    width: '100%',
    maxWidth: '100%',
    overflowX: 'auto',
    overflowWrap: 'anywhere',
    wordBreak: 'break-word'
  };
  useEffect(() => {
    // Manipulate the DOM to override styles for the "panel" class
    const container = containerRef.current;
    if (!container) {
      return;
    }
    const panelElements = container.getElementsByClassName('panel');

    for (let i = 0; i < panelElements.length; i++) {
      const panelElement = panelElements[i];
      // Add your custom styles for the "panel" class here

      panelElement.style.padding = '10px';

      // Add any other custom styles you need
    }

    const mediaElements = container.querySelectorAll('img, table, pre');
    mediaElements.forEach((element) => {
      element.style.maxWidth = '100%';
    });

    const tableElements = container.getElementsByTagName('table');
    for (let i = 0; i < tableElements.length; i++) {
      tableElements[i].style.width = '100%';
    }
  }, [sanitizedHTML]);

  return (
    <div
      ref={containerRef}
      style={containerStyle}
      dangerouslySetInnerHTML={{ __html: sanitizedHTML }}
    />
  );
};

export default Jiraintercomdescription;
